<div class="catalogue-analysis-container" [class.fullscreen]="isFullscreen">
  <div class="tree-header">
    <h2>{{ 'catalogue.analysis.title' | transloco }}</h2>
    <div class="tree-controls">
      <button class="control-btn" (click)="expandAll()">
        {{ 'catalogue.analysis.expandAll' | transloco }}
      </button>
      <button class="control-btn" (click)="collapseAll()">
        {{ 'catalogue.analysis.collapseAll' | transloco }}
      </button>
      <button class="control-btn fullscreen-btn" (click)="toggleFullscreen()">
        <svg
          *ngIf="!isFullscreen"
          width="18"
          height="18"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2">
          <path
            d="M8 3H5a2 2 0 0 0-2 2v3m18 0V5a2 2 0 0 0-2-2h-3m0 18h3a2 2 0 0 0 2-2v-3M3 16v3a2 2 0 0 0 2 2h3"></path>
        </svg>
        <svg
          *ngIf="isFullscreen"
          width="18"
          height="18"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2">
          <path
            d="M8 3v3a2 2 0 0 1-2 2H3m18 0h-3a2 2 0 0 1-2-2V3m0 18v-3a2 2 0 0 1 2-2h3M3 16h3a2 2 0 0 1 2 2v3"></path>
        </svg>
        <span>
          {{
            isFullscreen
              ? ('catalogue.analysis.exitFullscreen' | transloco)
              : ('catalogue.analysis.enterFullscreen' | transloco)
          }}
        </span>
      </button>
    </div>
  </div>

  <div class="tree-legend">
    <div class="legend-item">
      <span class="legend-color positive"></span>
      <span>{{ 'catalogue.analysis.positive' | transloco }}</span>
    </div>
    <div class="legend-item">
      <span class="legend-color negative"></span>
      <span>{{ 'catalogue.analysis.negative' | transloco }}</span>
    </div>
    <div class="legend-item">
      <span class="legend-color critical"></span>
      <span>{{ 'catalogue.analysis.critical' | transloco }}</span>
    </div>
    <div class="legend-item">
      <span class="legend-color neutral"></span>
      <span>{{ 'catalogue.analysis.neutral' | transloco }}</span>
    </div>
  </div>

  <div class="tree-viewport" #treeContainer></div>

  <div class="tree-info">
    <p>{{ 'catalogue.analysis.instructions' | transloco }}</p>
    <p class="scroll-hint">{{ 'catalogue.analysis.scrollHint' | transloco }}</p>
    <p class="fullscreen-hint" *ngIf="isFullscreen">
      {{ 'catalogue.analysis.fullscreenHint' | transloco }}
    </p>
  </div>
</div>
